import { render, staticRenderFns } from "./StockviewPriceChange.vue?vue&type=template&id=c3a1b410&"
import script from "./StockviewPriceChange.vue?vue&type=script&lang=js&"
export * from "./StockviewPriceChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports